import React, { useContext } from "react";
import useReviews from "../reviews/useReviews";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { VariantContextData } from "../variants/VariantBuilderContext";

const NewReview = (props) => {
  const { Reviews } = useReviews();
  const [contextData, builder] = useContext(VariantContextData);

  const createReview = _.debounce(() => {
    let element_reviews = props.object.options["reviews-ids"]?.split(",")?.filter(id => id !== '') || [];

    Reviews.create({
      title: `Review ${element_reviews.length + 1}`,
    }, (review) => {
      element_reviews.push(review.id);

      builder.update([
        {
          object_type: props.object_type,
          object_id: props.object.id,
          setting_name: "[options][reviews-ids]",
          value: element_reviews.join(",")
        },
        {
          object_type: props.object_type,
          object_id: props.object.id,
          setting_name: "[options][reviews-last-updated]",
          value: Date.now().toString()
        }
      ]);

      // Wait for the review to be rendered in the DOM, then open the edit modal
      setTimeout(() => {
        dispatchCustomEvent("focusItem", {
          parent_id: props.object.id,
          item_type: "reviews",
          item_id: review.id
        });
      }, 300);
    });
  }, 200);

  return (
    <React.Fragment>
      <div className="row hard-center">
        <button
          onClick={createReview}
          className="w-full p-2 text-left bg-transparent border-none text-xl text-blue-600 dark:text-blue-200 dark:hover:text-white"
          title="Add Review"
        >
          <FontAwesomeIcon icon="plus-square" className="mr-2 text-2xl" /> Add Review
        </button>
      </div>
    </React.Fragment>
  );
};

export default NewReview;
